<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
  [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">
  <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>
  <kendo-textbox-container class="form-element">
    <ng-container *ngIf="labelName">
      <div [innerHtml]="labelName | localizeLabel"></div>
    </ng-container>
    <input kendoCheckbox type="checkbox" [id]="controlId ? controlId : labelName" #formCheckBox class="k-checkbox"
      [disabled]="isFieldDisabled" [(ngModel)]="internalValue" (ngModelChange)="updateCheckbox()">
    <label class="k-checkbox-label pre ml-15" [for]="controlId ? controlId : labelName" [innerHtml]="checkboxLabel"></label>
    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>